export default __webpack_public_path__ + "static/media/information--stop-permitted--g1.686135de.png";